import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AiCardNarrationBlock } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-card-narration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-card-narration.component.html',
  styleUrl: './response-card-narration.component.css',
})
export class ResponseCardNarrationComponent {
  @Input({ required: true }) block!: AiCardNarrationBlock;
}
